import { AxiosPromise } from "axios";
import configs from "../configs";
import { SuperAdminLiveApi } from "./live/superAdminLiveApi";

export class SuperAdminApis {
    private static adminApi: SuperAdminLiveApi = new SuperAdminLiveApi();

    static getlinksCount(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getlinksCount();
        }
    }

    static getAllUsers(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllUsers(pageNo, query);
        }
    }


    static getShipmentManifestInfo(shipmentNumbers: string[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getShipmentManifestInfo(shipmentNumbers);
        }
    }


    static getReimbursements(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.getReimbursements(query); }
    }

    static createReimbursement(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.createReimbursement(data); }
    }

    static approveReimbursementL1(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.approveReimbursementL1(id, data); }
    }

    static approveReimbursementL2(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.approveReimbursementL2(id, data); }
    }

    static rejectReimbursement(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.rejectReimbursement(id, data); }
    }

    static getReimbursementFleetDropdown(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.getReimbursementFleetDropdown(); }
    }

    static getFleetManifestShipments(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        else { return this.adminApi.getFleetManifestShipments(query); }
    }

    static updateDocketNumbers(pairs: { number: string; docket: string; date?: string; account_code?: string }[], commit: boolean): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateDocketNumbers(pairs, commit);
        }
    }

    static uploadImportExcelBatch(data: {
        header: string[];
        rows: any[][];
        batch_number: number;
        total_batches: number;
    }): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadImportExcelBatch(data);
        }
    }


    static getNigerianStates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getNigerianStates();
        }
    }

    static getNigerianCities(state: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getNigerianCities(state);
        }
    }

    static getRiderMetroCities(riderProfileId: number): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getRiderMetroCities(riderProfileId);
        }
    }

    static syncRiderMetroCities(riderProfileId: number, cities: any[]): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.syncRiderMetroCities(riderProfileId, { cities });
        }
    }

    static getAllInvoices(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllInvoices(pageNo, query);
        }
    }

    static getAllExpense(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllExpense(pageNo, query);
        }
    }

    static validateShipmentNumbers(shipmentNumbers: string[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.validateShipmentNumbers(shipmentNumbers);
        }
    }

    static getShipmentStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getShipmentStats();
        }
    }

    static prepareMassUpdate(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.prepareMassUpdate(data);
        }
    }

    static exportAllExpenses(query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.exportAllExpenses(query);
        }
    }

    static sendInvoice(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.sendInvoice(data);
        }
    }

    static getCustomersForDropdown(type: string, search: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCustomersForDropdown(type, search);
        }
    }

    static previewInvoice(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.previewInvoice(data);
        }
    }

    // ── Expense voucher approval workflow ──────────────────────
    static getVoucherLevels(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getVoucherLevels();
    }

    static getVoucherApproverCandidates(search: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getVoucherApproverCandidates(search);
    }

    static createVoucherLevel(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.createVoucherLevel(data);
    }

    static updateVoucherLevel(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.updateVoucherLevel(id, data);
    }

    static reorderVoucherLevels(levelIds: number[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.reorderVoucherLevels(levelIds);
    }

    static deleteVoucherLevel(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.deleteVoucherLevel(id);
    }

    static getVoucherTimeline(voucherId: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getVoucherTimeline(voucherId);
    }

    static approveVoucherStep(voucherId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.approveVoucherStep(voucherId, data);
    }

    static rejectVoucherStep(voucherId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.rejectVoucherStep(voucherId, data);
    }

    static resubmitVoucher(voucherId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.resubmitVoucher(voucherId, data);
    }

    static bulkMarkInvoicesPaid(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.bulkMarkInvoicesPaid(data);
        }
    }

    static downloadInvoicePdf(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadInvoicePdf(data);
        }
    }

    static getAllRiders(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllRiders(pageNo, query);
        }
    }


    static getAllFleetsForDropdown(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllFleetsForDropdown();
        }
    }




    static getAllRidersByFleet(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllRidersByFleet(id);
        }
    }

    static getAllFleet(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllFleet(pageNo, query);
        }
    }


    static getAllFleetWithoutPagination(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllFleetWithoutPagination(pageNo, query);
        }
    }




    static getAllStaffs(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllStaffs(pageNo, query);
        }
    }

    static getAllGms(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllGms(pageNo, query);
        }
    }


    static getTotalBranch(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getTotalBranch(pageNo, query);
        }
    }

    static getAllBranch(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllBranch(pageNo, query);
        }
    }

    static createBranch(zoneName: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createBranch(zoneName);
        }
    }


    static exportMultipleRunwayManifests(manifestIds: number[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.exportMultipleRunwayManifests(manifestIds);
        }
    }

    static exportMultipleManifests(manifestIds: number[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.exportMultipleManifests(manifestIds);
        }
    }


    static getStatesByZone(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getStatesByZone(data);
        }
    }




    //Credit Customer
    static createCreditCustomer(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createCreditCustomer(data);
        }
    }

    static createExpenseVoucher(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createExpenseVoucher(data);
        }
    }

    static getAllCreditCustomers(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllCreditCustomers(pageNo, query);
        }
    }

    static getAllExpenseVoucher(filters: Record<string, any> = {}): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllExpenseVoucher(filters);
        }
    }

    static exportAllFilteredManifests(filters: {
        search?: string;
        start_date?: string;
        end_date?: string;
        sender_state?: string;
        destination_state?: string;
        sender_branch?: string;
        destination_branch?: string;
        type?: string;
        created_by?: string;
    }): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.exportAllFilteredManifests(filters);
        }
    }

    static getSingleCreditCustomers(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleCreditCustomers(id);
        }
    }

    static getSingleExpenseVoucher(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleExpenseVoucher(id);
        }
    }

    static updateToReview(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateToReview(data);
        }
    }

    static approveByHod(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.approveByHod(data);
        }
    }

    static deleteVoucher(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteVoucher(data);
        }
    }

    static rejectByHod(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.rejectByHod(data);
        }
    }

    static approveByAudit(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.approveByAudit(data);
        }
    }

    static rejectByAudit(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.rejectByAudit(data);
        }
    }

    static approveByGm(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.approveByGm(data);
        }
    }

    static rejectByGm(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.rejectByGm(data);
        }
    }

    static approveBygrouphead(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.approveBygrouphead(data);
        }
    }

    static rejectByGrouphead(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.rejectByGrouphead(data);
        }
    }

    static disburseByFinance(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.disburseByFinance(data);
        }
    }

    static updateCreditCustomer(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateCreditCustomer(data);
        }
    }

    static updateVoucher(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateVoucher(data);
        }
    }

    static updateToApproved(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateToApproved(data);
        }
    }

    //Audit
    static getAudits(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAudits(pageNo, query);
        }
    }

    static createAudit(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createAudit(data);
        }
    }

    //Vehicles
    static getAllVehicle(pageNo: any, query: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllVehicle(pageNo, query, id);
        }
    }

    static createVehicle(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createVehicle(data);
        }
    }

    static updateVehicle(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateVehicle(data);
        }
    }

    static deleteVehicle(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteVehicle(data);
        }
    }

    static calculateRate(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.calculateRate(data);
        }
    }

    static createRider(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createRider(data);
        }
    }

    static createFleet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createFleet(data);
        }
    }

    static createManifest(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createManifest(data);
        }
    }


    // ==================== AIRWAYBILL NUMBER METHODS ====================

    static getAllAirwaybillNumbers(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllAirwaybillNumbers(query);
        }
    }

    static getAirwaybillNumbersDropdown(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAirwaybillNumbersDropdown();
        }
    }

    static getSingleAirwaybillNumber(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleAirwaybillNumber(id);
        }
    }

    static createAirwaybillNumber(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createAirwaybillNumber(data);
        }
    }

    static updateAirwaybillNumber(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateAirwaybillNumber(id, data);
        }
    }

    static deleteAirwaybillNumber(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteAirwaybillNumber(id);
        }
    }

    // ENHANCED MANIFEST METHODS WITH FILTERING

    // Enhanced getAllManifest method that supports both simple and advanced filtering
    static getAllManifest(query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            // Check if query has advanced filtering parameters
            if (query && (query.start_date || query.end_date || query.sender_state || query.destination_state || query.type || query.created_by)) {
                return this.adminApi.getAllManifestEnhanced(query);
            } else {
                // Use original method for backward compatibility
                return this.adminApi.getAllManifest(query);
            }
        }
    }

    // Get manifests with enhanced filtering support
    static getAllManifestWithFilters(filters: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllManifestEnhanced(filters);
        }
    }

    // Get manifests by date range
    static getManifestsByDateRange(filters: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getManifestsByDateRange(filters);
        }
    }

    // Get outbound manifests (filtered by sender_state)
    static getOutboundManifests(filters: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getOutboundManifests(filters);
        }
    }

    // Get inbound manifests (filtered by destination_state)
    static getInboundManifests(filters: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getInboundManifests(filters);
        }
    }

    // Get manifest statistics with filtering
    static getManifestStats(filters: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getManifestStats(filters);
        }
    }

    // EXISTING MANIFEST METHODS (keeping for backward compatibility)

    static getAllManifestByAdmin(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllManifestByAdmin(pageNo, query);
        }
    }

    static getAllManifestByOffice(outPage: any, inPage: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllManifestByOffice(outPage, inPage, query);
        }
    }

    static getSingleManifest(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleManifest(id);
        }
    }

    static updateManifest(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateManifest(data);
        }
    }

    // Run Manifest methods (keeping existing)
    static createRunManifest(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createRunManifest(data);
        }
    }

    static getDeliveryPayments(params: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getDeliveryPayments(params);
    }

    static getDeliveryPaymentStats(params: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getDeliveryPaymentStats(params);
    }

    static getAllRunManifest(pageNo: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllRunManifest(pageNo, query);
        }
    }


    static downloadShipmentTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadShipmentTemplate();
        }
    }

    static downloadSimpleTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadSimpleTemplate();
        }
    }

    static getSingleRunManifest(id: any, query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleRunManifest(id, query);
        }
    }

    static updateRunManifest(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateRunManifest(data);
        }
    }

    // Staff methods (keeping existing)
    static createStaff(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.createStaff(data);
        }
    }

    static async getPendingFinesStats(params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getPendingFinesStats(params);
        }
        return { data: { status: true, data: {} } };
    }

    static adminFullUpdateApplication(id: number, data: FormData): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.adminFullUpdateApplication(id, data);
        }
    }

    static updateStaff(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateStaff(data);
        }
    }

    static deleteStaff(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteStaff(data);
        }
    }

    // Location methods (keeping existing)
    static getAllCountryFrom(pageNo: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllCountryFrom(pageNo);
        }
    }

    static addCountryFrom(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addCountryFrom(data);
        }
    }

    static addCountryTo(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addCountryTo(data);
        }
    }

    static addStateFrom(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addStateFrom(data);
        }
    }

    static addLgaFrom(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addLgaFrom(data);
        }
    }

    static addLgaTo(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addLgaTo(data);
        }
    }

    static addStateTo(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.addStateTo(data);
        }
    }

    static updateCountryFrom(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateCountryFrom(data, id);
        }
    }

    static updatestateFrom(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updatestateFrom(data, id);
        }
    }

    static updateLgaFrom(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateLgaFrom(data, id);
        }
    }

    static updateLgaTo(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateLgaTo(data, id);
        }
    }

    static updatestateTo(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updatestateTo(data, id);
        }
    }

    static updateCountryTo(data: any, id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateCountryTo(data, id);
        }
    }

    static deleteCountryFrom(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteCountryFrom(id);
        }
    }

    static deleteStateFrom(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteStateFrom(id);
        }
    }

    static deleteLgaFrom(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteLgaFrom(id);
        }
    }

    static deleteLgaTo(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteLgaTo(id);
        }
    }

    static deleteStateTo(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteStateTo(id);
        }
    }

    static deleteCountryTo(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteCountryTo(id);
        }
    }

    static getAllCountryTo(pageNo: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllCountryTo(pageNo);
        }
    }

    static getAllStateFrom(pageNo: any, data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllStateFrom(pageNo, data);
        }
    }

    static getAllStateTo(pageNo: any, data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllStateTo(pageNo, data);
        }
    }

    static getAllLgaFrom(pageNo: any, data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllLgaFrom(pageNo, data);
        }
    }

    static getAllLgaTo(pageNo: any, data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllLgaTo(pageNo, data);
        }
    }

    static uploadLgaToExcel(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadLgaToExcel(data);
        }
    }

    static uploadLgaTCreditCustomerExcel(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadLgaTCreditCustomerExcel(data);
        }
    }

    static uploadCountryToExcel(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCountryToExcel(data);
        }
    }

    static uploadImportExcel(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadImportExcel(data);
        }
    }

    // ==================== PAYMENT MANAGEMENT ====================

    static getPaymentPipelineStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getPaymentPipelineStats();
    }

    static getAllPayments(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAllPayments(query);
    }

    static getPendingConfirmationPayments(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getPendingConfirmationPayments(query);
    }

    static confirmPayment(id: number, data?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.confirmPayment(id, data);
    }

    static bulkConfirmPayments(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.bulkConfirmPayments(data);
    }

    static filterConfirmPayments(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.filterConfirmPayments(data);
    }

    static getAnalyticsDashboard(params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAnalyticsDashboard(params);
    }

    static getAnalyticsRefresh(params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAnalyticsRefresh(params);
    }

    static getConfirmedPayments(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getConfirmedPayments(query);
    }

    static approvePayment(id: number, data?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.approvePayment(id, data);
    }

    static bulkApprovePayments(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.bulkApprovePayments(data);
    }

    static filterApprovePayments(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.filterApprovePayments(data);
    }

    static approvePaymentsByBalance(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.approvePaymentsByBalance(data);
    }

    static rejectPayment(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.rejectPayment(id, data);
    }

    static bulkRejectPayments(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.bulkRejectPayments(data);
    }

    // ==================== LEGACY MIGRATION ====================

    static getLegacyMigrationStats(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLegacyMigrationStats();
    }

    static getUnmigratedFleets(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getUnmigratedFleets(query);
    }

    static getUnmigratedRiders(query: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getUnmigratedRiders(query);
    }

    static migrateFleet(userId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.migrateFleet(userId, data);
    }

    static migrateRider(userId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.migrateRider(userId, data);
    }

    static bulkMigrateLegacy(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.bulkMigrateLegacy(data);
    }

    static applyFine(userId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.applyFine(userId, data);
    }

    static async updateFacilityFineSettings(data: { facility_base_fine_rate: number; facility_grace_period_hours: number }): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().updateFacilityFineSettings(data);
        }
        return { success: true, message: "Facility fine settings updated." };
    }

    static getAnalyticsAirwaybillShipments(params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAnalyticsAirwaybillShipments(params);
    }

    static getAnalyticsAttemptedDeliveryShipments(params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAnalyticsAttemptedDeliveryShipments(params);
    }

    static async toggleFacilityFineSettings(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().toggleFacilityFineSettings();
        }
        return { success: true, data: { facility_fine_enabled: false } };
    }


    static getAnalyticsFineShipments(params?: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAnalyticsFineShipments(params);
    }


    // ── Fine Settings ────────────────────────────────────────────────────────

    static async getFineSettings(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getFineSettings();
        }
        // LOCAL fallback if you use local data
        return { success: true, data: { base_fine_rate: 50, grace_period_hours: 24, is_enabled: true } };
    }

    static async updateFineSettings(data: {
        base_fine_rate: number;
        grace_period_hours: number;
    }): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().updateFineSettings(data);
        }
        return { success: true, message: "Fine settings updated." };
    }


    // ── Admin Wallet Management ─────────────────────────────────────────

    static async getAdminWallets(params: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAdminWallets(params);
        }
        return { data: { status: true, data: [] } };
    }

    static async getAdminWalletStats(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAdminWalletStats();
        }
        return { data: { status: true, data: {} } };
    }

    static async exportAdminWallets(params: any = {}): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().exportAdminWallets(params);
        }
        return { data: new Blob([], { type: 'text/csv' }) };
    }

    static async getAdminWalletDetail(userId: number, params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAdminWalletDetail(userId, params);
        }
        return { data: { status: true, data: {} } };
    }

    static async toggleAdminWalletStatus(userId: number, data?: { reason?: string }): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().toggleAdminWalletStatus(userId, data);
        }
        return { data: { status: true, message: "Wallet status updated." } };
    }

    static async resetWalletPin(userId: number): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().resetWalletPin(userId);
        }
        return { data: { status: true, message: "Withdrawal PIN has been reset." } };
    }

    static async getAdminWithdrawals(params: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAdminWithdrawals(params);
        }
        return { data: { status: true, data: [], summary: {} } };
    }

    static async getPayoutProvider(): Promise<any> {
        return await new SuperAdminLiveApi().getPayoutProvider();
    }

    static async switchPayoutProvider(data: { provider: string; note?: string }): Promise<any> {
        return await new SuperAdminLiveApi().switchPayoutProvider(data);
    }

    static async reverifyPayoutBanks(limit = 20, retryFailed = false): Promise<any> {
        return await new SuperAdminLiveApi().reverifyPayoutBanks(limit, retryFailed);
    }

    static async getPayoutBankFailures(): Promise<any> {
        return await new SuperAdminLiveApi().getPayoutBankFailures();
    }

    static async getWithdrawalDetails(id: number): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getWithdrawalDetails(id);
        }
        return { data: { status: true, data: {} } };
    }

    static async syncWithdrawal(id: number): Promise<any> {
        return await new SuperAdminLiveApi().syncWithdrawal(id);
    }

    static async retryWithdrawal(id: number): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().retryWithdrawal(id);
        }
        return { data: { status: true, message: "Retry initiated." } };
    }

    static async markWithdrawalComplete(id: number, data?: { notes?: string }): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().markWithdrawalComplete(id, data);
        }
        return { data: { status: true, message: "Marked as completed." } };
    }

    static async toggleFineSettings(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().toggleFineSettings();
        }
        return { success: true, data: { is_enabled: false } };
    }

    // ── Auto-attempt automation (SLA protection) ──────────────

    static async updateAutoAttemptSettings(data: {
        auto_attempt_hours: number;
        auto_attempt_minutes: number;
        auto_attempt_fine_amount: number;
        auto_attempt_scope: string;
    }): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().updateAutoAttemptSettings(data);
        }
        return { success: true };
    }

    static async toggleAutoAttemptSettings(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().toggleAutoAttemptSettings();
        }
        return { success: true, data: { auto_attempt_enabled: false } };
    }

    // ── Auto-attempted deliveries report (read-only) ──────────

    static async getAutoAttemptedDeliveries(params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAutoAttemptedDeliveries(params);
        }
        return { status: true, data: { data: [], total: 0 } };
    }

    static async getAutoAttemptedStats(params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAutoAttemptedStats(params);
        }
        return { status: true, data: {} };
    }

    static async getAutoAttemptedGrouped(params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAutoAttemptedGrouped(params);
        }
        return { status: true, data: [] };
    }

    static async getAutoAttemptedFilterOptions(): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().getAutoAttemptedFilterOptions();
        }
        return { status: true, data: {} };
    }

    static async exportAutoAttemptedDeliveries(params?: any): Promise<any> {
        if (configs.type === "REST") {
            return await new SuperAdminLiveApi().exportAutoAttemptedDeliveries(params);
        }
        return null;
    }

    static uploadCountryToCreditCustomerExcel(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCountryToCreditCustomerExcel(data);
        }
    }

    static updateShipmentData(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateShipmentData(data);
        }
    }

    static updateShipmentStatus(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateShipmentStatus(data);
        }
    }

    static updateShipmentStatusForDelivery(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateShipmentStatusForDelivery(data);
        }
    }

    static updateMultipleShipmentStatus(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateMultipleShipmentStatus(data);
        }
    }

    /**
 * Get shipments for batch update - returns shipment numbers and recommended batch size
 */
    static getManifestShipmentsForBatchUpdate(manifestId: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getManifestShipmentsForBatchUpdate(manifestId);
        }
    }

    /**
     * Update manifest metadata only (first step of batch update process)
     * Returns shipment_numbers array for frontend batching
     */
    static updateManifestMetadata(manifestId: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateManifestMetadata(manifestId, data);
        }
    }

    /**
     * Process a batch of shipments for manifest status update
     * Called multiple times by frontend for each batch of shipments
     */
    static batchUpdateManifestShipments(data: {
        manifest_id: any;
        shipment_numbers: string[];
        new_status: string;
        status_id: any;
        batch_number: number;
        total_batches: number;
        event_datetime: string;
    }): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.batchUpdateManifestShipments(data);
        }
    }

    static updateShipmentOffice(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateShipmentOffice(data);
        }
    }

    static updateRider(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateRider(data);
        }
    }

    static updateFleet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateFleet(data);
        }
    }

    static deleteFleet(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteFleet(data);
        }
    }

    static deleteRider(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteRider(data);
        }
    }

    static updateBranch(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateBranch(data);
        }
    }

    static deleteBranch(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteBranch(data);
        }
    }

    static getAllShipments(data: any, query: any, viewType: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllShipments(data, query, viewType);
        }
    }

    static getAllShipmentsForExport(query: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllShipmentsForExport(query);
        }
    }

    static updateShipmentRider(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.updateShipmentRider(data);
        }
    }

    static deleteShipment(data: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.deleteShipment(data);
        }
    }

    static getSingleUserShipment(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getSingleUserShipment(id);
        }
    }

    static getsingleUserData(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getsingleUserData(id);
        }
    }


    /**
 * Get branches filtered by state for cascading dropdown
 */
    static getBranchesByState(state: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getBranchesByState(state);
        }
    }





    // Domestic Rates
    static uploadDomesticRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadDomesticRates(data);
        }
    }

    static getAllDomesticRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllDomesticRates();
        }
    }

    static downloadDomesticRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadDomesticRateTemplate();
        }
    }

    // Bulk Rates
    static uploadBulkRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadBulkRates(data);
        }
    }

    static getAllBulkRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllBulkRates();
        }
    }

    static downloadBulkRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadBulkRateTemplate();
        }
    }

    // Bulk Extra Rates
    static uploadBulkExtraRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadBulkExtraRates(data);
        }
    }

    static getAllBulkExtraRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllBulkExtraRates();
        }
    }

    static downloadBulkExtraRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadBulkExtraRateTemplate();
        }
    }

    // Express Rates
    static uploadExpressRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadExpressRates(data);
        }
    }

    static getAllExpressRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllExpressRates();
        }
    }

    static downloadExpressRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadExpressRateTemplate();
        }
    }

    // Export Rates
    static uploadExportRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadExportRates(data);
        }
    }

    static getAllExportRates(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllExportRates();
        }
    }

    static downloadExportRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadExportRateTemplate();
        }
    }







    /**
     * Get unique states from branches for state dropdown
     */
    static getStatesFromBranches(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getStatesFromBranches();
        }
    }

    /**
     * Get all branches as simple list for filtering
     */
    static getAllBranchesSimple(): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getAllBranchesSimple();
        }
    }


    // ==================== CREDIT CUSTOMER RATE METHODS ====================

    // Fixed Rates
    static uploadCreditCustomerFixedRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerFixedRates(data);
        }
    }

    static getCreditCustomerFixedRates(clientId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerFixedRates(clientId);
        }
    }

    static downloadFoodRateTemplate(): AxiosPromise<any> {
        return this.adminApi.downloadFoodRateTemplate();
    }

    static exportFoodRates(clientId?: string): AxiosPromise<any> {
        return this.adminApi.exportFoodRates(clientId);
    }

    static uploadFoodRates(data: FormData): AxiosPromise<any> {
        return this.adminApi.uploadFoodRates(data);
    }

    static deleteAllFoodRates(clientId?: string): AxiosPromise<any> {
        return this.adminApi.deleteAllFoodRates(clientId);
    }

    // ── Standard (cash) rate cards ─────────────────────────────────────
    static updateStandardRateRow(type: string, id: any, data: any): AxiosPromise<any> {
        return this.adminApi.updateStandardRateRow(type, id, data);
    }

    static deleteStandardRateRow(type: string, id: any): AxiosPromise<any> {
        return this.adminApi.deleteStandardRateRow(type, id);
    }

    static deleteAllStandardRates(type: string): AxiosPromise<any> {
        return this.adminApi.deleteAllStandardRates(type);
    }

    static exportStandardRates(type: string): AxiosPromise<any> {
        return this.adminApi.exportStandardRates(type);
    }

    // ── Food items tariff ──────────────────────────────────────────────
    static getFoodRateOptions(clientId?: string): AxiosPromise<any> {
        return this.adminApi.getFoodRateOptions(clientId);
    }

    static getFoodRates(clientId?: string): AxiosPromise<any> {
        return this.adminApi.getFoodRates(clientId);
    }

    static updateFoodRate(id: any, data: any): AxiosPromise<any> {
        return this.adminApi.updateFoodRate(id, data);
    }

    static deleteFoodRate(id: any): AxiosPromise<any> {
        return this.adminApi.deleteFoodRate(id);
    }

    static saveFoodDocumentCharge(data: any): AxiosPromise<any> {
        return this.adminApi.saveFoodDocumentCharge(data);
    }

    // ── Rate card admin: edit / delete / export ────────────────────────
    static createCreditRateRow(type: string, data: any): AxiosPromise<any> {
        return this.adminApi.createCreditRateRow(type, data);
    }

    static updateCreditRateRow(type: string, id: any, data: any): AxiosPromise<any> {
        return this.adminApi.updateCreditRateRow(type, id, data);
    }

    static deleteCreditRateRow(type: string, id: any): AxiosPromise<any> {
        return this.adminApi.deleteCreditRateRow(type, id);
    }

    static deleteAllCreditRates(type: string, clientId: string): AxiosPromise<any> {
        return this.adminApi.deleteAllCreditRates(type, clientId);
    }

    static exportCreditRates(type: string, clientId: string): AxiosPromise<any> {
        return this.adminApi.exportCreditRates(type, clientId);
    }

    // Credit customer express rates. Not zone-based; shares the standard express
    // table, scoped to this customer.
    static uploadCreditCustomerExpressRates(data: any): AxiosPromise<any> {
        return this.adminApi.uploadCreditCustomerExpressRates(data);
    }

    static getAllCreditCustomerExpressRates(clientId: string): AxiosPromise<any> {
        return this.adminApi.getAllCreditCustomerExpressRates(clientId);
    }

    static downloadCreditCustomerExpressRateTemplate(clientId?: string): AxiosPromise<any> {
        return this.adminApi.downloadCreditCustomerExpressRateTemplate(clientId);
    }

    // Zone configuration, per credit customer: which states sit in Zone 1-4 for one
    // customer. Nothing about the rate cards changes — only what each zone means.
    static getCreditCustomerZones(clientId: string, rateType: string): AxiosPromise<any> {
        return this.adminApi.getCreditCustomerZones(clientId, rateType);
    }

    static saveCreditCustomerZones(clientId: string, rateType: string, zones: any[], states: any[]): AxiosPromise<any> {
        return this.adminApi.saveCreditCustomerZones(clientId, rateType, zones, states);
    }

    static resetCreditCustomerZones(clientId: string, rateType: string): AxiosPromise<any> {
        return this.adminApi.resetCreditCustomerZones(clientId, rateType);
    }

    static downloadCreditCustomerFixedRateTemplate(clientId?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadCreditCustomerFixedRateTemplate(clientId);
        }
    }

    // Bulk Rates
    static uploadCreditCustomerBulkRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerBulkRates(data);
        }
    }

    static getCreditCustomerBulkRates(clientId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerBulkRates(clientId);
        }
    }

    static downloadCreditCustomerBulkRateTemplate(clientId?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadCreditCustomerBulkRateTemplate(clientId);
        }
    }

    // Flat Rates
    static uploadCreditCustomerFlatRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerFlatRates(data);
        }
    }

    static getCreditCustomerFlatRates(clientId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerFlatRates(clientId);
        }
    }

    static downloadCreditCustomerFlatRateTemplate(clientId?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadCreditCustomerFlatRateTemplate(clientId);
        }
    }

    // Multiplier Rates
    static uploadCreditCustomerMultiplierRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerMultiplierRates(data);
        }
    }

    static getCreditCustomerMultiplierRates(clientId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerMultiplierRates(clientId);
        }
    }

    static downloadCreditCustomerMultiplierRateTemplate(clientId?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadCreditCustomerMultiplierRateTemplate(clientId);
        }
    }

    // Special Rates
    static uploadCreditCustomerSpecialRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerSpecialRates(data);
        }
    }

    static getCreditCustomerSpecialRates(clientId: string): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerSpecialRates(clientId);
        }
    }

    static downloadCreditCustomerSpecialRateTemplate(clientId?: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadCreditCustomerSpecialRateTemplate(clientId);
        }
    }

    // Calculate Credit Customer Rate
    static calculateCreditCustomerRate(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.calculateCreditCustomerRate(data);
        }
    }


    // LGA Domestic Rates
    static uploadLgaDomesticRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadLgaDomesticRates(data);
        }
    }

    static getLgaDomesticRates(stateName: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getLgaDomesticRates(stateName);
        }
    }

    static downloadLgaDomesticRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadLgaDomesticRateTemplate();
        }
    }

    // LGA Bulk Rates
    static uploadLgaBulkRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadLgaBulkRates(data);
        }
    }

    static getLgaBulkRates(stateName: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getLgaBulkRates(stateName);
        }
    }

    static downloadLgaBulkRateTemplate(): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.downloadLgaBulkRateTemplate();
        }
    }


    // Credit Customer LGA Domestic Rates
    static uploadCreditCustomerLgaDomesticRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerLgaDomesticRates(data);
        }
    }

    static getCreditCustomerLgaDomesticRates(clientId: string, stateName: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerLgaDomesticRates(clientId, stateName);
        }
    }

    // Credit Customer LGA Bulk Rates
    static uploadCreditCustomerLgaBulkRates(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.uploadCreditCustomerLgaBulkRates(data);
        }
    }

    static getCreditCustomerLgaBulkRates(clientId: string, stateName: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getCreditCustomerLgaBulkRates(clientId, stateName);
        }
    }


    static getLgasByState(stateName: string, serviceType: string = 'domestic', clientId: string = ''): AxiosPromise<any> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.getLgasByState(stateName, serviceType, clientId);
        }
    }

    // ── Rider Loans ────────────────────────────────────────────
    static getEligibleLoanRiders(search: string): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getEligibleLoanRiders(search);
    }

    static getLoanCleanupReview(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLoanCleanupReview();
    }

    static downloadLoanCleanupReport(): AxiosPromise<Blob> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise<Blob>; }
        return this.adminApi.downloadLoanCleanupReport();
    }

    static applyLoanCleanup(moves: any[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.applyLoanCleanup(moves);
    }

    static getRiderLoans(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getRiderLoans(params);
    }

    static recordRiderLoan(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.recordRiderLoan(data);
    }

    static getRiderLoanDetail(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getRiderLoanDetail(id);
    }

    static updateRiderLoan(id: number, data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.updateRiderLoan(id, data);
    }

    static cancelRiderLoan(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.cancelRiderLoan(id);
    }

    static getLoanWalletOverview(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLoanWalletOverview(params);
    }

    static getLoanWalletBankAccounts(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLoanWalletBankAccounts();
    }

    static saveLoanWalletBankAccount(data: any, id?: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.saveLoanWalletBankAccount(data, id);
    }

    static deleteLoanWalletBankAccount(id: number): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.deleteLoanWalletBankAccount(id);
    }

    static getLoanWalletWithdrawals(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLoanWalletWithdrawals(params);
    }

    /** The accounts behind the "rider negative exposure" total. Read-only. */
    static getLoanWalletNegativeExposure(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getLoanWalletNegativeExposure(params);
    }

    static loanWalletWithdraw(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.loanWalletWithdraw(data);
    }

    // ── Bulk Delivery Photos ───────────────────────────────────
    static uploadDeliveryPhoto(data: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.uploadDeliveryPhoto(data);
    }

    static getAwaitingDeliveryPhotos(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAwaitingDeliveryPhotos(params);
    }

    static lookupShipmentsForPod(shipmentNumbers: string[]): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.lookupShipmentsForPod(shipmentNumbers);
    }

    static getAwaitingDeliveryPhotoFilters(): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getAwaitingDeliveryPhotoFilters();
    }

    static bulkApplyDeliveryPhoto(data: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.bulkApplyDeliveryPhoto(data);
    }

    // ── Custom Duty Payments ───────────────────────────────────
    static customDutyParse(data: FormData): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.customDutyParse(data);
    }

    static customDutyProcessBatch(data: any): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.customDutyProcessBatch(data);
    }

    static getCustomDutyList(params: any = {}): AxiosPromise<any> {
        if (configs.type === "LOCAL") { return {} as AxiosPromise; }
        return this.adminApi.getCustomDutyList(params);
    }

    static async exportCustomDuty(params: any = {}): Promise<any> {
        if (configs.type === "LOCAL") { return {} as any; }
        return await this.adminApi.exportCustomDuty(params);
    }

    // ==================== CORPORATE CLIENT BILLING ====================
    // Newer convention: a fresh SuperAdminLiveApi per call, so the constructor picks
    // up the current token rather than the one captured at app boot.

    static async getBillingClients(): Promise<any> {
        return await new SuperAdminLiveApi().getBillingClients();
    }

    static async createBillingClient(data: any): Promise<any> {
        return await new SuperAdminLiveApi().createBillingClient(data);
    }

    static async deleteBillingClient(id: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteBillingClient(id);
    }

    static async updateBillingClient(id: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().updateBillingClient(id, data);
    }

    static async getBillingStates(): Promise<any> {
        return await new SuperAdminLiveApi().getBillingStates();
    }

    static async getBillingConfiguration(clientId: any): Promise<any> {
        return await new SuperAdminLiveApi().getBillingConfiguration(clientId);
    }

    static async getFfdxRunShipments(id: any, params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().getFfdxRunShipments(id, params);
    }

    static async reparseFfdxRun(id: any): Promise<any> {
        return await new SuperAdminLiveApi().reparseFfdxRun(id);
    }

    static async downloadFfdxPayload(id: any): Promise<any> {
        return await new SuperAdminLiveApi().downloadFfdxPayload(id);
    }

    static async getFfdxFeedRuns(params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().getFfdxFeedRuns(params);
    }

    static async getFfdxFeedStats(): Promise<any> {
        return await new SuperAdminLiveApi().getFfdxFeedStats();
    }

    static async getFfdxFeedRun(id: any): Promise<any> {
        return await new SuperAdminLiveApi().getFfdxFeedRun(id);
    }

    static async runFfdxFeed(data: any): Promise<any> {
        return await new SuperAdminLiveApi().runFfdxFeed(data);
    }

    static async fixUnmappedStates(data: any): Promise<any> {
        return await new SuperAdminLiveApi().fixUnmappedStates(data);
    }

    static async getNoDocketShipments(data: any): Promise<any> {
        return await new SuperAdminLiveApi().getNoDocketShipments(data);
    }

    static async getUnmappedStateShipments(data: any): Promise<any> {
        return await new SuperAdminLiveApi().getUnmappedStateShipments(data);
    }

    static async deleteClientInvoice(id: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteClientInvoice(id);
    }

    static async getReturnRate(clientId: any): Promise<any> {
        return await new SuperAdminLiveApi().getReturnRate(clientId);
    }

    static async saveReturnRate(clientId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().saveReturnRate(clientId, data);
    }

    static async previewReturnInvoice(data: any): Promise<any> {
        return await new SuperAdminLiveApi().previewReturnInvoice(data);
    }

    static async generateReturnInvoice(data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateReturnInvoice(data);
    }

    static async getInvoiceCompanies(): Promise<any> {
        return await new SuperAdminLiveApi().getInvoiceCompanies();
    }

    static async saveInvoiceCompany(id: any, data: any, logo: File | null): Promise<any> {
        return await new SuperAdminLiveApi().saveInvoiceCompany(id, data, logo);
    }

    static async deleteInvoiceCompany(id: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteInvoiceCompany(id);
    }

    static async getBillingDockets(clientId: any, search: string = '', clientIds: any[] = []): Promise<any> {
        return await new SuperAdminLiveApi().getBillingDockets(clientId, search, clientIds);
    }

    static async createBillingZone(clientId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().createBillingZone(clientId, data);
    }

    static async updateBillingZone(zoneId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().updateBillingZone(zoneId, data);
    }

    static async deleteBillingZone(zoneId: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteBillingZone(zoneId);
    }

    static async setBillingZoneStates(zoneId: any, states: string[]): Promise<any> {
        return await new SuperAdminLiveApi().setBillingZoneStates(zoneId, states);
    }

    static async createBillingCharge(clientId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().createBillingCharge(clientId, data);
    }

    static async updateBillingCharge(chargeId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().updateBillingCharge(chargeId, data);
    }

    static async deleteBillingCharge(chargeId: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteBillingCharge(chargeId);
    }

    // ── Temporary support passwords ────────────────────────────────────────
    static async getTemporaryPasswordHistory(userId: any): Promise<any> {
        return await new SuperAdminLiveApi().getTemporaryPasswordHistory(userId);
    }

    static async generateTemporaryPassword(userId: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateTemporaryPassword(userId, data);
    }

    static async revokeTemporaryPassword(userId: any): Promise<any> {
        return await new SuperAdminLiveApi().revokeTemporaryPassword(userId);
    }

    // ── Bank-transfer payment proofs ───────────────────────────────────────
    static async getUnpaidSenders(search = ''): Promise<any> {
        return await new SuperAdminLiveApi().getUnpaidSenders(search);
    }

    static async getUnpaidShipments(senderKey: string): Promise<any> {
        return await new SuperAdminLiveApi().getUnpaidShipments(senderKey);
    }

    static async listTransferRequests(params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().listTransferRequests(params);
    }

    static async createTransferRequest(data: any): Promise<any> {
        return await new SuperAdminLiveApi().createTransferRequest(data);
    }

    static async getTransferRequest(id: any): Promise<any> {
        return await new SuperAdminLiveApi().getTransferRequest(id);
    }

    static async verifyTransferRequest(id: any): Promise<any> {
        return await new SuperAdminLiveApi().verifyTransferRequest(id);
    }

    static async cancelTransferRequest(id: any): Promise<any> {
        return await new SuperAdminLiveApi().cancelTransferRequest(id);
    }

    static async listPaymentProofs(params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().listPaymentProofs(params);
    }

    static async getPaymentProof(id: any): Promise<any> {
        return await new SuperAdminLiveApi().getPaymentProof(id);
    }

    static async submitPaymentProof(form: FormData): Promise<any> {
        return await new SuperAdminLiveApi().submitPaymentProof(form);
    }

    static async confirmPaymentProof(id: any, data: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().confirmPaymentProof(id, data);
    }

    static async rejectPaymentProof(id: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().rejectPaymentProof(id, data);
    }

    static async previewClientInvoice(data: any): Promise<any> {
        return await new SuperAdminLiveApi().previewClientInvoice(data);
    }

    static async previewClientInvoiceStream(
        data: any,
        onProgress?: (processed: number, total: number) => void,
        signal?: AbortSignal,
    ): Promise<any> {
        return await new SuperAdminLiveApi().previewClientInvoiceStream(data, onProgress, signal);
    }

    static async generateClientInvoiceStream(
        data: any,
        onProgress?: (processed: number, total: number) => void,
        signal?: AbortSignal,
    ): Promise<any> {
        return await new SuperAdminLiveApi().generateClientInvoiceStream(data, onProgress, signal);
    }

    static async previewClientInvoiceBatch(data: any): Promise<any> {
        return await new SuperAdminLiveApi().previewClientInvoiceBatch(data);
    }

    static async previewClientInvoiceFinalise(data: any): Promise<any> {
        return await new SuperAdminLiveApi().previewClientInvoiceFinalise(data);
    }

    static async generateClientInvoiceStart(data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateClientInvoiceStart(data);
    }

    static async generateClientInvoiceBatch(data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateClientInvoiceBatch(data);
    }

    static async generateClientInvoiceFinalise(data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateClientInvoiceFinalise(data);
    }

    // Saved docket weights.
    static async listInvoiceWeightSheets(params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().listInvoiceWeightSheets(params);
    }

    static async saveInvoiceWeightSheet(data: any): Promise<any> {
        return await new SuperAdminLiveApi().saveInvoiceWeightSheet(data);
    }

    static async loadInvoiceWeightSheet(id: any, data: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().loadInvoiceWeightSheet(id, data);
    }

    static async deleteInvoiceWeightSheet(id: any): Promise<any> {
        return await new SuperAdminLiveApi().deleteInvoiceWeightSheet(id);
    }

    static async discardDraftInvoice(id: any): Promise<any> {
        return await new SuperAdminLiveApi().discardDraftInvoice(id);
    }

    static async generateClientInvoice(data: any): Promise<any> {
        return await new SuperAdminLiveApi().generateClientInvoice(data);
    }

    static async getClientInvoices(params: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().getClientInvoices(params);
    }

    static async getClientInvoice(id: any): Promise<any> {
        return await new SuperAdminLiveApi().getClientInvoice(id);
    }

    static async updateClientInvoiceStatus(id: any, data: any): Promise<any> {
        return await new SuperAdminLiveApi().updateClientInvoiceStatus(id, data);
    }

    static async voidClientInvoice(id: any, data: any = {}): Promise<any> {
        return await new SuperAdminLiveApi().voidClientInvoice(id, data);
    }

    static async exportClientInvoice(id: any): Promise<any> {
        return await new SuperAdminLiveApi().exportClientInvoice(id);
    }

    static async downloadClientInvoicePdf(id: any): Promise<any> {
        return await new SuperAdminLiveApi().downloadClientInvoicePdf(id);
    }
}